import { handleErrors } from "../util/api-utils";

export function addBankInfo(request, successCallback, errorCallback) {
    fetch("api/Billing/addBankInfo", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
};

export function getBankName(routingNumber, successCallback, errorCallback, finallyCallback) {
    fetch(`api/Billing/GetBankName?routingNumber=${encodeURIComponent(routingNumber)}`, {
        method: "get",
        headers: {
            "Accept": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
}

export function getBankInfo(successCallback, errorCallback, finallyCallback) {
    fetch("api/Billing/GetBankInfo", {
        method: "get",
        headers: {
            "Accept": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
}
